import { Outlet } from 'react-router-dom';

import { PageHeader } from '@/shared/components/PageHeader';
import { SidebarShell } from '@/shared/shell/SidebarShell';
import { AdminSidebar } from './AdminSidebar';

export function AdminLayout() {
  return (
    <>
      <PageHeader title="Admin" />
      <SidebarShell sidebar={<AdminSidebar />}>
        <div className="flex-1 overflow-y-auto">
          <div className="mx-auto flex max-w-7xl flex-col gap-10 px-12 py-8">
            <Outlet />
          </div>
        </div>
      </SidebarShell>
    </>
  );
}
